import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ThemeContext } from '../context/ThemeContext';
import api from '../utils/api';
import styles from './DashboardPage.module.css';

const DashboardPage = () => {
    const { token } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const usersRes = await api.get('/api/admin/users');
                const activeUsers = usersRes.data.filter(user => 
                    !user.name.startsWith('del_') && !user.email.startsWith('del_')
                );
                setUsers(activeUsers);
            } catch (err) {
                console.error('Failed to fetch users');
            }
        };
        fetchUsers();
    }, [token]);

    const handleUserClick = (userId, index) => {
        const allUserIds = users.map(user => user._id);
        sessionStorage.setItem('allUserIds', JSON.stringify(allUserIds));
        navigate(`/users/${userId}?currentIndex=${index}`);
    };

    const filteredUsers = users.filter(user => 
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (user.mobileNumber && user.mobileNumber.includes(searchTerm))
    );

    return (
        <div className={`${styles['dashboard-page']} ${styles[theme]}`}>
            <h2>List of Clients</h2>
            <div className={styles.searchContainer}>
                <input
                    type="text"
                    placeholder="Search by name, email or mobile..."
                    className={styles.searchInput}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            <div className={styles.userList}>
                {filteredUsers.map((user, index) => (
                    <div key={user._id} className={styles.userItem} onClick={() => handleUserClick(user._id, index)}>
                        <div className={styles.userItemContent}>
                            <span className={styles.userIndex}>{index + 1})</span>
                            <div className={styles.userInfo}>
                                <span className={styles.userName}>{user.name}</span>
                                <span className={styles.userEmail}>{user.email}</span>
                                <span className={styles.userMobile}>{user.mobileNumber}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardPage;
